import React from 'react';
import FinalForm from '@framework/ui/Organisms/FinalForm';
import {
  PORTFOLIO_REVIEW_UNKNOWNS_FIELD_ARRAY,
  PORTFOLIO_REVIEW_UNKNOWNS_FORM,
} from './constants';
import ReviewUnknownsFields from './ReviewUnknownsFields';
import { useStepFormContext } from '@/creditflowresearch/application/PortfolioMonitor/StepFormContext';
import useGetPositions from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/useGetPositions';

import formStyles from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm/formStyles.module.scss';

const ReviewUnknownsTable = (props) => {
  const { positions } = useGetPositions();
  const { goNext } = useStepFormContext();

  const submit = async () => {
    goNext();
  };

  return (
    <FinalForm
      className={ formStyles.virtualListContainer }
      dataTest={ PORTFOLIO_REVIEW_UNKNOWNS_FORM }
      render={ () => <ReviewUnknownsFields { ...props } /> }
      onSubmit={ submit }
      initialValues={ { [PORTFOLIO_REVIEW_UNKNOWNS_FIELD_ARRAY]: positions } }
    />
  );
};

export default ReviewUnknownsTable;
